import { useRouter } from 'next/router';
import styles from 'styles/modules/Box.module.scss';

const Box = (props) => {
    const { data } = props;
    if (!data) return null;

    const router = useRouter();

    const small = data.small ? (
        <small className={styles.small}>{data.small}</small>
    ) : null;
    const title = data.title ? (
        <h3 className={styles.title}>{data.title}</h3>
    ) : null;
    const body = data.body ? (
        <div
            className={styles.body}
            dangerouslySetInnerHTML={{ __html: data.body }}
        />
    ) : null;
    const cta = data.cta ? (
        <a
            className={styles.cta}
            onClick={
                data.cta.onClick
                    ? data.cta.onClick
                    : () => router.push(data.cta.href)
            }
        >
            {data.cta.title}
        </a>
    ) : null;

    return (
        <div
            className={[
                'border-gray',
                styles.box,
                styles[`box__${data.theme}`],
            ].join(' ')}
            onClick={data.boxClick && data.boxClick.onClick}
        >
            {small}
            {title}
            {body}
            {cta}
        </div>
    );
};

export default Box;
